import { Directive, ViewContainerRef } from '@angular/core';

@Directive({ selector: '[csWidgetCustomUi]' })
export class WidgetCustomUiDirective {
    constructor(public viewContainerRef: ViewContainerRef) {}
}
